import { memo, useEffect, useState } from "react";
import { createAppointmentApi } from "../api-helpers/AppointmentApiHelper";
import { workflowStatesCache } from "../grid/renderers/WorkflowStateCellValueGetter";
import { AppointmentHistoryConstants } from "../helper/WorkflowConstants";

export const RescheduledCountRenderer = memo(({ data }: { data: any }) => {
    const cache = new Map<string, number>();

  const getCachedCount = (appointmentId: string) => {
    return cache.get(appointmentId);
  };

  const cacheCount = (appointmentId: string, count: number) => {
    cache.set(appointmentId, count);
  };

    const [count, setCount] = useState<number | "Loading...">(() => getCachedCount(data.appointmentId) || "Loading...");
    const appointmentApi = createAppointmentApi();

    const fetchCount = async () => {
      const cachedCount = getCachedCount(data.appointmentId);
      if (cachedCount !== undefined) {
        setCount(cachedCount);
        return;
      }
      try {
        const history = await appointmentApi.appointmentControllerGetAppointmentHistories(data.appointmentId);
        const keysForRescheduled = Array.from(workflowStatesCache.entries()).find(
          ([key, val]) => val.toLowerCase().includes("reschedule") 
        )?.[0];
        const rescheduled = history.data.filter((data) => data.newValue === keysForRescheduled || data.fieldChanged === AppointmentHistoryConstants.APPOINTMENT_FIELD_TIME);
        cacheCount(data.appointmentId, rescheduled.length); // Cache result
        setCount(rescheduled.length);
        data.appointmentCount = rescheduled.length;
      } catch (error) {
        console.error("Error fetching rescheduled count:", error);
        setCount(0);
      }
    }; // Memoize to avoid unnecessary function re-creations

    useEffect(() => {
      if(data.appointmentCount !== undefined) {
        setCount(data.appointmentCount);
        return;
      }
      fetchCount();
    }, [data.appointmentId]); // Only re-run when `value` (appointmentId) changes

    return <span>{count}</span>;
  });